import Vue from 'vue';
import VueAnalytics from 'vue-analytics'
import App from './App.vue';
import VeeValidate, { Validator } from 'vee-validate';
import VueRouter from 'vue-router';
import VTooltip from 'v-tooltip';
import VueScrollTo from 'vue-scrollto';
import { routes } from './routes';
import localeDE from './config/de';
import * as veelidateConfig from './config/vee-validate';
import * as scrollToConfig from './config/scroll-to';
import tooltipOptions from './config/tooltip';


import '@fortawesome/fontawesome-free/css/all.css';
import "./styles/core.scss"

// required for webpack file loader
require('../favicon.ico');

// localizing the validation tips
Validator.localize('de', localeDE);

Vue.use(VeeValidate, veelidateConfig);
Vue.use(VueRouter);
Vue.use(VTooltip, tooltipOptions);
Vue.use(VueScrollTo);
Vue.use(VueScrollTo, scrollToConfig);


if(process.env.BRAND === 'default' || process.env.BRAND === 'hausnotruf-testen') {
  Vue.use(VueAnalytics, {
    id: 'UA-135129660-1'
  });
}

const router = new VueRouter({
  routes,
  mode: 'history'
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js